import { Link as BaseLink } from "@/i18n/Link";
import { classed } from "@frend-digital/ui";
import styles from "./Login/Login.module.css";

const Root = classed.div(styles.root);

const Container = classed.div(styles.container);

const Title = classed.h1(styles.title);

const ImageContainer = classed.div(styles.imageContainer);

const Link = classed(BaseLink, styles.link);
const ErrorText = classed.p(styles.error);

export { Container, ErrorText, ImageContainer, Link, Root, Title };
